<template>
  <v-flex class="section-1 general-bg" ma-0 pt-4 px-4>
    <!-- DIALOG AGENCIES -->
    <v-dialog
      v-model="showAgencies"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-flex class="text-xs-center" px-2 pt-3 pb-2>
          <h2>Seleccionar Agencia</h2>
        </v-flex>
        <agencies-tree :from-section="fromSection" />
        <v-flex d-flex pa-3 mx-2>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="cancelAngeciesTree"
          >
            Cancelar
        </v-btn>
          <v-btn
            color="primary"
            :disabled="agencySelected === null"
            @click="showAgencies = false"
          >
            Aceptar
          </v-btn>
        </v-flex>
      </v-card>
    </v-dialog>
    <h3 class="text-xs-left pt-2">Exceso de Velocidad</h3>
    <h4 class="text-xs-left pt-2">Reporte por Tiempo</h4>
    <!-- SELECT AGENCY -->
    <v-flex my-2 py-3>
      <v-flex class="caption" pl-2>*Opcional</v-flex>
      <h5 class="pl-2">Seleccionar Agencia</h5>
      <v-btn
        color="primary"
        block
        :loading="$loading.isLoading('fetchingAgenciesTree')"
        @click="showAgencies = true"
      >
        <v-icon left>business</v-icon>
        Agencias
      </v-btn>
      <!-- AGENCY SELECTED -->
      <v-flex v-if="agencySelected && !$loading.isLoading('fetchingAgenciesTree')" pl-2>
        <h6>Agenica Seleccionada</h6>
        <h5>{{ agencySelected.name }}</h5>
      </v-flex>
    </v-flex>
    <!-- DATE & TIME -->
    <v-flex px-1 mt-3>
      <!-- DATE INTERVAL FOR DATE1 & DATE2 -->
      <v-flex>
        <v-menu
          lazy
          ref="menu0"
          v-model="menu0"
          transition="scale-transition"
          :close-on-content-click="false"
          :return-value.sync="dates0"
          offset-x
          left
          full-width
          origin="top left"
          nudge-right="300"
          nudge-top="-40"
          color="white">
          <template v-slot:activator="{ on }">
            <v-combobox
              v-model="dates0"
              multiple
              chips
              small-chips
              label="Fecha"
              placeholder="Escoger el día a consultar"
              prepend-inner-icon="event"
              readonly
              box
              color="white"
              v-on="on">
            </v-combobox>
          </template>
          <v-date-picker
            v-model="dates0"
            multiple
            no-title
            scrollable
            :first-day-of-week="1"
            locale="es-sp"
            :allowed-dates="allowedDates0"
            color="blue accent-3"
            @input="changesDate0">
            <v-spacer></v-spacer>
            <v-btn color="error" @click="menu0 = false">Cancelar</v-btn>
            <v-btn color="primary" @click="acceptDate0">Aceptar</v-btn>
          </v-date-picker>
        </v-menu>
      </v-flex>
      <!-- MENU TIME 1 DATE 1 -->
      <v-flex v-if="showInitialTime0">
          <!-- :disabled="eventsLoaded" -->
          <!-- class="mx-1" -->
          <!-- nudge-top="300" -->
          <!-- nudge-left="-10" -->
        <v-menu
          ref="time1Date1Menu0"
          lazy
          :close-on-content-click="false"
          v-model="time1Date1Menu0"
          transition="scale-transition"
          offset-x
          left
          full-width
          allow-overflow
          min-width="290px"
          origin="top left"
          nudge-right="750"
          nudge-bottom="0"
          :return-value.sync="time1Date10">
            <!-- :disabled="eventsLoaded" -->
          <v-text-field
            slot="activator"
            label="Hora Inicial"
            placeholder="Seleccionar Hora"
            v-model="time1Date10"
            prepend-inner-icon="av_timer"
            readonly
            box
            hide-details
            color="white"/>
          <v-time-picker
            landscape
            v-model="time1Date10"
            format="24hr"
            scrollable
            color="teal darken-1"
            header-color="grey darken-4"
            @input="changeTime10">
            <!-- @change="$refs.time1Date1Menu.save(time1Date1)" -->
            <v-spacer></v-spacer>
            <v-btn color="error" @click="time1Date1Menu0 = false">Cancelar</v-btn>
            <v-btn color="primary" @click="acceptTime10">Aceptar</v-btn>
          </v-time-picker>
        </v-menu>
      </v-flex>
      <!-- TIME 2 DATE 1 MENU -->
      <v-flex v-if="showFinalTime0" mt-3>
          <!-- :disabled="eventsLoaded" -->
          <!-- class="mx-1" -->
          <!-- nudge-top="-15" -->
        <v-menu
          ref="time2Date1Menu0"
          lazy
          :close-on-content-click="false"
          v-model="time2Date1Menu0"
          transition="scale-transition"
          offset-x
          left
          full-width
          min-width="290px"
          origin="top left"
          nudge-right="750"
          nudge-bottom="0"
          :return-value.sync="time2Date10">
            <!-- :disabled="eventsLoaded" -->
          <v-text-field
            slot="activator"
            label="Hora Final"
            placeholder="Seleccionar Hora"
            v-model="time2Date10"
            prepend-inner-icon="av_timer"
            readonly
            box
            hide-details
            color="white"/>
          <v-time-picker
            landscape
            v-model="time2Date10"
            format="24hr"
            scrollable
            :allowed-hours="allowedHours0"
            :allowed-minutes="allowedMinutes0"
            color="red darken-1"
            header-color="grey darken-4"
            @click:hour="hourClicked0"
            @change="changeTime20">
            <!-- @change="$refs.time2Date1Menu.save(time2Date1)" -->
            <v-spacer></v-spacer>
            <v-btn color="error" @click="time2Date1Menu0 = false">Cancelar</v-btn>
            <v-btn color="primary" @click="$refs.time2Date1Menu0.save(time2Date10)">Aceptar</v-btn>
          </v-time-picker>

        </v-menu>
      </v-flex>
    </v-flex>
    <!-- MIN VALUES -->
    <v-flex v-if="showFinalTime0" pt-3>
      <v-flex>
        <v-subheader class="pt-0 pl-0">Velocidad Mínima del Exceso (Km/h)</v-subheader>
        <v-slider
          v-model="minSpeed"
          :max="250"
          :min="60"
          always-dirty
          persistent-hint
          thumb-label="always"
          thumb-size="24"
          prepend-inner-icon="speed"
        ></v-slider>
      </v-flex>
      <v-flex class="min-speed-style">
        <v-subheader class="pt-0 pl-0">Tiempo Mínimo del Exceso (seg)</v-subheader>
         <v-text-field
          v-model="minTime"
          label="Tiempo Mínimo"
          placeholder="Tiempo en segundos"
          type="number"
          :min="minTimeValue"
          :max="maxTimeValue"
          prepend-inner-icon="av_timer"
          hide-details
          box
          color="white"
          @change="minTimeProcess"
        />
      </v-flex>
    </v-flex>
    <!-- BUTTON -->
    <v-flex class="text-xs-center" my-4 pb-3>
        <!-- :href="urlReportPoint" -->
      <v-btn
        v-if="!reportReadyGSTR"
        :disabled="reportTimeDisabled"
        @click="downloadSpeedTimeReport"
        target="_blank"
        color="primary"
        block
        :loading="$loading.isLoading('generatingSpeedTimeReport')">
        <v-icon left>description</v-icon>
        Generar Reporte
      </v-btn>
      <v-btn
        v-if="reportReadyGSTR"
        :href="urlReportGSTR"
        target="_blank"
        color="success"
        block
        @click="toggleBtnGSTR(false)"
      >
        <v-icon left>cloud_download</v-icon>
        Descargar Reporte
      </v-btn>
    </v-flex>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import AgenciesTree from '../AgenciesTree.vue'

export default {
  name: 'report-by-speed-time',
  components: {
    AgenciesTree
  },
  data() {
    return {
      minTimeValue: 8,
      maxTimeValue: 32400,
      minTime: 8,
      minSpeed: 60,
      amountOfHours: 9,
      time2Date1Menu0: false,
      limitHour0: null,
      limitMinute0: null,
      limitTime0: null,
      onlyDate10: null,
      onlyDate20: null,
      date10: null,
      date20: null,
      dates0: [],
      showFinalTime0: false,
      time2Date10: null,
      showInitialTime0: false,
      time1Date1Menu0: false,
      time1Date10: null,
      menu0: false,
      showOk: false,
      showStop: false,
      searchAction: false,
      searchVehicleValue: null,
      fromSection: 'report-by-speed-time',
      showAgencies: false
    }
  },
  computed: {
    ...mapGetters(['reportReadyGSTR', 'urlReportGSTR', 'agencySelected']),
    reportTimeDisabled() {
      let result = true
      if (this.dates0.length === 1 && this.time1Date10 && this.time2Date10) result = false
      return result
    }
  },
  methods: {
    ...mapActions([
      'toggleBtnGSTR',
      'getSpeedTimeReport'
    ]),
    minTimeProcess() {
      // console.log('CHANGE: ', this.minTime)
      if (this.minTime < this.minTimeValue) this.minTime = this.minTimeValue
      else if (this.minTime > this.maxTimeValue) this.minTime = this.maxTimeValue
    },
    allowedDates0(date) {
      let today = this.$moment.now()
      let datesResult = this.$moment(date).isBefore(today)
      today = this.$moment(today).format('YYYY-MM-DD')

      if (this.dates0.length === 1) datesResult = date === this.dates0[0]

      return datesResult
    },
    downloadSpeedTimeReport() {
      const payload = {
        fromDate: `${this.date10} ${this.time1Date10}`,
        toDate: `${this.date20} ${this.time2Date10}`,
        duration: this.minTime,
        limit: this.minSpeed
      }
      if (this.agencySelected) payload.agencyId = this.agencySelected.agencyId
      this.getSpeedTimeReport(payload)
    },
    changesDate0() {
      // console.log('CHANGE DATE')
      if (this.dates0.length === 0) {
        this.showInitialTime0 = false
        this.showFinalTime0 = false
        this.onlyDate10 = null
        this.onlyDate20 = null
        this.date10 = null
        this.date20 = null
        this.limitTime0 = null
        this.limitHour0 = null
        this.limitMinute0 = null
        this.time1Date1Menu0 = false
        this.time1Date10 = null
        this.time2Date1Menu0 = false
        this.time2Date10 = null
      }
    },
    changeTime10() {
      // console.log('CHANGE TIME 10')
      this.time2Date10 = null
    },
    hourClicked0(value) {
      // console.log('HOUR CLICKED', value)
    },
    changeTime20() {
      // console.log('CHANGE TIME 2', this.time1Date10, this.time2Date10)
      // const startTime = this.$moment(this.time1Date10, 'HH:mm')
      // const finalTime = this.$moment(this.time2Date10, 'HH:mm')
      // console.log('startTime: ', startTime)
      // console.log('finalTime: ', finalTime)
      // const differenceTime = this.$moment.startTime.diff(finalTime, 'hours')
      // console.log('DIFF: ', differenceTime)
    },
    allowedMinutes0(value) {
      if (this.time2Date10 !== null) {
        const selectedHour = this.time2Date10.split(':')
        if (Number(selectedHour[0]) === Number(this.limitHour0)) {
          if (value <= this.limitMinute0) return true
          else return false
        }
      }
      return true
    },
    allowedHours0(value) {
      const myDate = `${this.dates0[0]} ${this.time1Date10}`
      this.date10 = this.dates0[0]

      if (this.time2Date10) {
        const selectedHour1 = this.time1Date10.split(':')
        const selectedHour2 = this.time2Date10.split(':')
        let myDate2 = null

        if (Number(selectedHour2[0]) < Number(selectedHour1[0]) && this.onlyDate10 !== this.onlyDate20) myDate2 = this.onlyDate20
        else myDate2 = this.dates0[0]

        this.date20 = this.$moment(myDate2).format('YYYY-MM-DD')
      }

      const allowedHoursArray = []
      for (let i = 0; i <= this.amountOfHours; i++) {
        const h = this.$moment(myDate).add(i, 'hours').format('H')
        allowedHoursArray.push(Number(h))
      }

      this.limitTime0 = this.$moment(myDate).add(this.amountOfHours, 'hours').format('YYYY-MM-DD HH:mm:ss')
      this.onlyDate10 = this.$moment(myDate).format('YYYY-MM-DD')
      this.onlyDate20 = this.$moment(myDate).add(this.amountOfHours, 'hours').format('YYYY-MM-DD')
      this.limitHour0 = this.$moment(this.limitTime0).format('H')
      this.limitMinute0 = this.$moment(this.limitTime0).format('mm')

      const isIn = allowedHoursArray.filter(item => item === value)
      if (isIn.length > 0) {
        return true
      } else return false
    },
    acceptTime10() {
      this.$refs.time1Date1Menu0.save(this.time1Date10)
      this.time2Date10 = this.time1Date10
      this.showFinalTime0 = true
    },
    acceptDate0() {
      this.$refs.menu0.save(this.dates0)
      this.time1Date10 = '00:00'
      this.showInitialTime0 = true
    },
    cancelAngeciesTree() {
      this.showAgencies = false
    }
  }
}
</script>

<style lang="stylus" scoped>
h3
  font-size 30px
  font-weight 500
  line-height 7px

h4
  font-size 21px
  font-weight 500

.min-speed-style
  margin-top -20px  

.section-1
  min-width 390px
  max-width 390px
  
.general-bg
  background-color #424242
  border-radius 3px   
</style>


// WEBPACK FOOTER //
// src/components/Reports/ReportBySpeedTime.vue